export function isPrimitiveType(type) {
    const isArray = Array.isArray(type);
    const primitiveTypes = ['string', 'number', 'boolean', 'integer', 'null'];

    return primitiveTypes.includes(isArray ? type[0] : type);
}
